import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/store';
import { Navigate } from 'react-router-dom';

type Props = {
  children?: ReactNode;
};

/**
 * ログインしていないとログイン画面にリダイレクトするコンポーネント
 */
function AuthenticatedOnly({ children }: Props) {
  const accessToken = useSelector(
    (state: AppState) => state.tokens.accessToken
  );

  if (!accessToken) return <Navigate to="/login" />;
  return <>{children}</>;
}

export default AuthenticatedOnly;
